
export const GET_ACCESSORY_PROMO_DATA = '@@storefront/GET_ACCESSORY_PROMO_DATA';

export const getAccessoryPromoData = () => ({ type: GET_ACCESSORY_PROMO_DATA });
